// extracted by mini-css-extract-plugin
module.exports = {"ctn":"About_ctn__1qKY7","title":"About_title__ezTei","version":"About_version__2l-sg","descrption":"About_descrption__1UsoI"};